import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var SliderTrackHorizontal = function () {
    return React.createElement("div", { className: IdStyles.SliderTrackHorizontalBackground });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/SliderTrackHorizontal.tsx
// module id = 2254
// module chunks = 3